import CupcakeCastles from '../Assets/Images/ClientReviewAssets/cupcake.avif';
import CupcakeCastlesLogo from '../Assets/Images/ClientReviewAssets/cctclogo.avif';
import GreenLabReviewLog from '../Assets/Images/ClientReviewAssets/GreenLabHumotron.avif';
import IndyraLogo from '../Assets/Images/ClientReviewAssets/humotron.avif';
import FlexeAppLogo from '../Assets/Images/flexeapp-logo.avif';
import LauriBurg from '../Assets/Images/ClientReviewAssets/Cupcake-Laurie-Burg.avif';
import PranavSir from '../Assets/Images/ClientReviewAssets/Cupcake-Pranav-Sir.avif';
import VikramSir from '../Assets/Images/ClientReviewAssets/VikramSir.avif';
import ChinmayBhatt from '../Assets/Images/ClientReviewAssets/GreenLab-Chinmay-Bhatt.avif';
import BigKhetiLogo from '../Assets/Images/bigkheti-slider/big_kheti.avif';
import NatrajSir from '../Assets/Images/ClientReviewAssets/natarajSir3.avif';
import RapidDox from '../Assets/Images/ClientReviewAssets/rapid.avif';
import calculatorTimesLogo from '../Assets/Images/ClientReviewAssets/CalculatorTimesLogo.avif';
import RapidoxWhiteLogo from '../Assets/Images/ClientReviewAssets/rapiddoxwhite.avif';
import BigKhetiBlack from '../Assets/Images/ClientReviewAssets/BigKhetiBlack.avif';
import SandipImg from '../Assets/Images/ClientReviewAssets/SandipSir.avif';
import SandipProjectImg from '../Assets/Images/ClientReviewAssets/SandipSir-Project.avif';

const ClientReviewList = [
  {
    clientImg: LauriBurg,
    clientPhoto: LauriBurg,
    projectLogo: CupcakeCastles,
    testimonialLogo: CupcakeCastlesLogo,
    projectName: 'Cupcake Castles',
    clientName: 'Laurie Burg',
    clientPosition: 'CEO - Cupcake Castles Travel Company (USA)',
    clientReview:
      "Pixerfect Solutions LLP's resources are a highly responsive and dedicated professionals, who consistently provides valuable input, demonstrates proactive problem-solving skills, and cares about the success of their clients."
  },
  {
    clientImg: ChinmayBhatt,
    clientPhoto: ChinmayBhatt,
    projectLogo: GreenLabReviewLog,
    testimonialLogo: IndyraLogo,
    projectName: 'Green Lab: Personalized Health Solutions',
    clientName: 'Chinmay Bhatt',
    clientPosition: 'Owner - Humotron (UK)',
    clientReview:
      'Over the past three years, Pixerfect Solutions LLP has been instrumental in developing GreenLab, our e-commerce platform for health products and data tracking. Their technical expertise, creativity, and professionalism consistently delivered high-quality results on time. I highly recommend them for any development projects.'
  },
  {
    clientImg: VikramSir,
    clientPhoto: VikramSir,
    projectLogo: FlexeAppLogo,
    testimonialLogo: FlexeAppLogo,
    projectName: 'Flexe App',
    clientName: 'Vikram Channagiri',
    clientPosition: 'Owner - Flexe App (USA)',
    clientReview:
      'Working with Pixerfect Solutions LLP has been a great experience overall. I personally visited Office and had the opportunity to connect with the team face to face, and every employee was extremely polite, professional, and supportive. They understood our requirements clearly, maintained excellent communication, and delivered quality work on time. We are very satisfied with the results and would highly recommend their services.'
  },
  {
    clientImg: NatrajSir,
    clientPhoto: NatrajSir,
    projectLogo: RapidoxWhiteLogo,
    testimonialLogo: RapidDox,
    projectName: 'RapidDox',
    clientName: 'Nataraj K',
    clientPosition: 'Founder - Factual Soft (USA)',
    clientReview:
      'Pixerfect Solutions LLP was a fantastic partner in our software development journey. Their due diligence from day one gave us confidence that every requirement was well understood and thoughtfully executed. The quality of their work was consistently high, with clean, reliable implementations and attention to detail. Even after delivery, their support remained responsive and dependable, making them feel like an extension of our own team. Highly recommended for anyone looking for a professional and trustworthy development partner.'
  },
  {
    clientImg: PranavSir,
    clientPhoto: PranavSir,
    projectLogo: BigKhetiLogo,
    testimonialLogo: BigKhetiBlack,
    projectName: 'Big Kheti',
    clientName: 'Pranav Sir',
    clientPosition: 'Chief Operating Officer - Big Kheti (USA)',
    clientReview:
      'Pixerfect Solutions LLP exceeded our expectations by providing tailored IT solutions that greatly improved our operations. Their professionalism and unmatched dedication resulted in exceptional service that we highly recommend to other businesses.'
  },
  {
    clientImg: SandipImg,
    clientPhoto: SandipImg,
    projectLogo: SandipProjectImg,
    testimonialLogo: calculatorTimesLogo,
    projectName: 'Mausam & CalculatorTimes',
    clientName: 'Sandip Kalsariya',
    clientPosition: 'Owner - CalculatorTimes (IND)',
    clientReview:
      'I am incredibly pleased with the outstanding services provided by Pixerfect Solutions LLP. They expertly crafted two exceptional websites for my projects. Mausam offers precise and user-friendly weather forecasts for all countries, while CalculatorTimes simplifies complex calculations with its diverse range of online calculators. The team is professionalism, creativity, and attention to detail exceeded my expectations.'
  }
];
export default ClientReviewList;
